import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {ImageProps} from 'app/utilities/ImageProps';

type ServiceCenterMarketingItemProps = {
  title: string;
  subtitle: string;
  image: ImageProps;
  description: string;
  link: {
    title: string;
    href: string;
  };
};

const ServiceCenterMarketingItem = ({title, subtitle, description, link, image}: ServiceCenterMarketingItemProps) => (
  <div className='ServiceCenterMarketingItem'>
    <div className='ServiceCenterMarketingItem__title'>{title}</div>
    <div className='ServiceCenterMarketingItem__subtitle'>{subtitle}</div>
    <Image className='ServiceCenterMarketingItem__image' {...image} />
    <div className='ServiceCenterMarketingItem__description'>{description}</div>
    <a className='ServiceCenterMarketingItem__link' href={link.href}>
      {link.title}
    </a>
  </div>
);

export default ServiceCenterMarketingItem;
